import { Route, Switch } from "react-router-dom";
import ExecucaoOrcamentariaListagemPage from "./Listagem";
import DetalhesExecucaoOrcamentaria from "./Detalhes/DetalheExecucaoOrcamentaria/index";

function ExecucaoOrcamentariaPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/execucao-orcamentaria"
        component={ExecucaoOrcamentariaListagemPage}
      />
      <Route
        exact
        path="/financeiro/execucao-orcamentaria/:id"
        component={DetalhesExecucaoOrcamentaria}
      />
    </Switch>
  );
}

export default ExecucaoOrcamentariaPages;
